
import { Component, Vue } from 'vue-property-decorator';
import AproconFooter from '@aprocon-software/aprocon-footer';
import AproconHeader from '@aprocon-software/aprocon-header';

@Component({
    components: { AproconFooter, AproconHeader },
})
export default class App extends Vue {

    private initialized: boolean = false;
    private activeTab: string = '';

    public created(): void {
        this.init();
    }

    private get title(): string {
        const packageJson = require('../package.json');
        const formVersion = packageJson.dependencies['@aprocon-software/aprocon-form'];
        return `APRO.CON Template App v${formVersion}`;

    }

    private async init(): Promise<void> {
        this.activeTab = this.$route.path;
        await this.$store.dispatch('Auth/login');
        this.keepAlive();
        this.initialized = true;
    }

    private keepAlive(): void {
        this.$store.dispatch('Auth/keepAlive')
            .then((success: boolean) => {
                if (success) {
                    // test credentials every 60 seconds
                    setTimeout(this.keepAlive, 1000 * 60);
                } else {
                    this.$store.dispatch('Auth/login');
                }
            })
            .catch((e) => {
                this.$store.dispatch('Auth/login');
            });
    }
}
